// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionSettingsController = function ($scope, $rootScope, $routeParams, $location, ExternalSubscriptionSettings) {
    $scope.settingsLoaded = false;
    if ($routeParams.type) {
        $scope.type = $routeParams.type;
        ExternalSubscriptionSettings.get({ type: $routeParams.type }).$promise.then(function (response) {
            $scope.settings = response;
            $scope.settingsLoaded = true;
        });
    } else {
        $scope.externalSubscriptionSettingsList = ExternalSubscriptionSettings.query();
    }

    $scope.save = function () {
        $scope.settings.$update({ type: $routeParams.type }, function (data) {
            $location.path("/settings/external-subscriptions");
        });
    };

    $scope.pushNotificationsUrl = `${window.location.origin}/ExternalSubscriptionsNotifications/${$routeParams.type}/${$rootScope.chosenEntity.Id}`;
};
ExternalSubscriptionSettingsController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', 'ExternalSubscriptionSettings'];
